var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('accounting-mutation',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var isSaving = ref.isSaving;
var syncInvoiceToProvider = ref.syncInvoiceToProvider;
var deleteInvoice = ref.deleteInvoice;
return [_c('finance-tracker-document-popover',{attrs:{"documents":_vm.invoices,"fn-delete":deleteInvoice,"fn-sync":syncInvoiceToProvider},on:{"change":function($event){return _vm.$emit('change')}}},[_vm._t("default")],2)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }